import { render, staticRenderFns } from "./TelaPrincipal.vue?vue&type=template&id=39a28996&scoped=true&"
import script from "./TelaPrincipal.vue?vue&type=script&lang=js&"
export * from "./TelaPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./TelaPrincipal.vue?vue&type=style&index=0&id=39a28996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a28996",
  null
  
)

export default component.exports